import {
    setOnlineToken
} from '@/router/interceptors';

export default {
    methods: {
        async addOnlineTokenToRequest() {
            const isOnlineTokenExists = this.$onlineToken.isExists();

            if (!isOnlineTokenExists) {
                this.$onlineToken.set();
            }

            setOnlineToken(this.$onlineToken.get());
        }

    }
}